import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from '../store';

type ModalVisible =
  | 'Hidden'
  | 'WalletDetail'
  | 'ChooseCoin'
  | 'TaxInformation'
  | 'NetworkAlert'
  | 'TimeoutLogout';

type ModalStatusSending = 'LOADING' | 'SUCCESS' | 'ERROR';

type ModalState = {
  // 팝업되는 모달 종류
  modalShowing: ModalVisible;
  modalStatusSending: ModalStatusSending;
  isWalletApproved: boolean;
};

const initialState: ModalState = {
  modalShowing: `Hidden`,
  modalStatusSending: `LOADING`,
  isWalletApproved: false,
};

const modalSlice = createSlice({
  name: `modal`,
  initialState,
  reducers: {
    reset: (state) => ({
      ...initialState,
    }),
    setModal: (state, action: PayloadAction<ModalState['modalShowing']>) => {
      state.modalShowing = action.payload;
    },

    setIsWalletApproved: (state, action) => {
      state.isWalletApproved = action.payload;
    },
  },
});

export const { reset, setModal, setIsWalletApproved } = modalSlice.actions;

export default modalSlice.reducer;

export const selectModalSlice = (state: RootState): ModalState => state.modal;
